import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';

import { UserContext } from '../../../contexts/UserContext';
import PermissionsAlert from '../../../components/PermissionsAlert/PermissionsAlert';
import {
  CUSTOM_REPORTS,
  getCustomReportLink,
  getEnabledCustomReportKeys,
} from '../../../constants/customReports';

const CustomReport = () => {
  const { reportKey } = useParams();
  const { dbUser } = useContext(UserContext);

  if (!dbUser) {
    return null;
  }

  const corporateClient =
    dbUser.userCorporateClients.length === 1
      ? dbUser.userCorporateClients[0].corporateClient
      : null;

  if (
    !corporateClient ||
    !reportKey ||
    (!dbUser.userPermissions.BasicReports &&
      !dbUser.userPermissions.AdminReports) ||
    !getEnabledCustomReportKeys(
      corporateClient.config_parsed?.custom_reports,
    ).includes(reportKey)
  ) {
    return <PermissionsAlert />;
  }

  return (
    <iframe
      title={`${CUSTOM_REPORTS[reportKey].label} report`}
      src={getCustomReportLink(reportKey, corporateClient.uuid)}
      style={{ width: '100%', height: 'calc(100vh - 82px)', border: '0' }}
    />
  );
};

export default CustomReport;
